import { Button, message } from "antd";
import { WplywContext } from "../../../../context/wplywContext";
import { useContext } from "react";
import axios from "../../../../context/axiosConfig";
import { useAuth } from "../../../../context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import { ConfirmStatusManualStage } from "./Confirm/ConfirmStatus";
import { useEffect } from "react";
import { useState } from "react";
import isCan from "../../../../components/isCan";
import { useActiveTab } from "../../../../context/activeTabContext";

const SaveButton = () => {
	const { wplyw, setWplyw } = useContext(WplywContext);
	const { user, isAuthenticated } = useAuth();
	const { wplywid } = useParams();
	const navigate = useNavigate(); // Dodano useNavigate
	const isConfirmStatusValid = ConfirmStatusManualStage();
	const perms = user.perms;
	const { activeTabX, setActiveTab } = useActiveTab();
	const [cando, setCando] = useState(false); // Stan dla uprawnień

	// Użycie useEffect do ustawiania wymaganych uprawnień
	useEffect(() => {
		const fetchPermissions = async () => {
			let requiredPerms = [];
			if (activeTabX.activeKey == "1") {
				requiredPerms = ["can_edit_dane_wplywu"];
			} else if (activeTabX.activeKey == "2") {
				requiredPerms = ["can_edit_persons"];
			} else if (
				activeTabX.activeKey == "3" &&
				activeTabX.innerActiveKey == "1"
			) {
				requiredPerms = ["can_edit_kwoty"];
			} else if (
				activeTabX.activeKey == "3" &&
				activeTabX.innerActiveKey == "2"
			) {
				requiredPerms = ["can_edit_rachunki"];
			}
			// Dodaj inne warunki, jeśli potrzebne
			const result = await isCan(requiredPerms, perms);
			setCando(result);
		};
		fetchPermissions();
	}, [activeTabX, perms]);

	const saveDataToDatabase = async (addnew = false) => {
		const hide = message.loading("Zapisywanie danych...", 0);
		try {
			const response = await axios.post("/wplyw/update/data", {
				wplyw: wplyw.wplyw_data.data.msr_wplywy,
				userid: user.user.mlg_users_id,
				changes: wplyw.changes,
			});

			if (response.data.status) {
				message.success("Dane zapisane pomyślnie!");

				if (wplywid === "nowy" && response.data?.id) {
					if (addnew) {
						setWplyw({
							...wplyw,
							reload: !wplyw.reload,
							changes: [],
							saved: true,
						});
						navigate(`/wplywy/nowy`, { bypassBlocker: true });
					} else {
						navigate(`/wplywy/${response.data.id}`, {
							bypassBlocker: true,
						});
						setWplyw({
							...wplyw,
							msr_wplywy_id: response.data.id,
							reload: !wplyw.reload,
							changes: [],
							saved: true,
						});
					}
				} else {
					setWplyw({
						...wplyw,
						msr_wplywy_id: wplywid,
						reload: !wplyw.reload,
						changes: [],
					});
				}
			} else {
				message.error(`Błąd zapisu: ${response.data.message}`);
			}
		} catch (error) {
			console.error("Error saving data:", error);
			const serverMessage = error?.response?.data?.message;
			message.error(
				serverMessage
					? `Błąd zapisu: ${serverMessage}`
					: "Wystąpił błąd podczas zapisywania danych."
			);
		} finally {
			hide();
		}
	};

	return (
		cando && (
			<div style={{ display: "flex", gap: "10px" }}>
				<Button
					disabled={
						!(wplyw?.changes?.length > 0 && isConfirmStatusValid)
					}
					onClick={() => saveDataToDatabase(false)}
				>
					Zapisz
				</Button>
				{activeTabX.activeKey == "1" && wplywid === "nowy" && (
					<Button
						disabled={
							!(
								wplyw?.changes?.length > 0 &&
								isConfirmStatusValid
							)
						}
						onClick={() => saveDataToDatabase(true)}
					>
						Zapisz i dodaj nowy
					</Button>
				)}
			</div>
		)
	);
};

export default SaveButton;
